/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PickDto } from '../../models/pick-dto';

export interface PickControllerFindPopularPlaces$Params {
}

export function pickControllerFindPopularPlaces(http: HttpClient, rootUrl: string, params?: PickControllerFindPopularPlaces$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PickDto>>> {
  const rb = new RequestBuilder(rootUrl, pickControllerFindPopularPlaces.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PickDto>>;
    })
  );
}

pickControllerFindPopularPlaces.PATH = '/api/picks/popular-places';
